import React from 'react';
import { Download } from 'lucide-react';
import { RobbieMark } from '../../ui';

/**
 * Robbie's starter-file bar, above the Step 1 drop zone. Buyers guess at what
 * a BOM should contain, and thin sheets produce thin research — so the sample
 * (a filled drone build) leads and the empty template follows. AI-carrying
 * container → ai-panel wash + robbie border, mark for attribution; the links
 * are the user's own action, so they stay cobalt. Plain anchors to the static
 * files in public/ — no endpoint, nothing to fail.
 */

const FILES = [
  { href: '/bom-template.xlsx', label: 'Blank template' },
  { href: '/bom-sample.xlsx', label: 'Filled sample BOM' },
] as const;

export const BomStarterFiles: React.FC = () => (
  <div className="flex flex-wrap items-center gap-x-s5 gap-y-s3 border-b border-robbie-border bg-ai-panel px-[18px] py-[12px]">
    <RobbieMark size="xs" aria-label="Robbie" />
    <p className="m-0 min-w-[240px] flex-1 text-body-sm text-ink-body">
      Any format works — but the more of these details you give me, the better my research gets. Grab the
      sample if you want to see what good looks like.
    </p>
    <span className="flex shrink-0 flex-wrap items-center gap-x-s5 gap-y-s2">
      {FILES.map(({ href, label }) => (
        <a
          key={href}
          href={href}
          download
          className="inline-flex items-center gap-s2 text-body-sm font-semibold text-action hover:underline
            focus:outline-none focus-visible:ring-2 focus-visible:ring-action focus-visible:ring-offset-1"
        >
          <Download className="h-[13px] w-[13px] shrink-0" />
          {label}
          <span className="font-mono text-[11px] font-normal text-ink-muted">XLSX</span>
        </a>
      ))}
    </span>
  </div>
);

export default BomStarterFiles;
